import App from './App.vue'
import { createApp } from 'vue'
import router from './router'
import store from './store'
import AdSpot from './components/AdSpot.vue'
import VueClickAway from "vue3-click-away";

import Axios from 'axios'
import VueAxios from 'vue-axios'
Axios.defaults.headers.Authorization = localStorage.getItem('arcane_token');
Axios.defaults.headers.common['x-user-agent'] = 'Arcane-Bot-5.0';
Axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const app = createApp(App)
    .use(VueAxios, Axios)
    .use(store)
    .use(router)
    .component('AdSpot', AdSpot)
    .use(VueClickAway)
    .mount('#app');

window.Chargebee.init({
    site: process.env.VUE_APP_CHARGEBEE_SITE,
    iframeOnly: true,
})
